import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import history from '../../../history'
import QuestionSingle from '../Questions/QuestionSingleContainer'
import { Text, Button, Page } from '../..'
import {
  selectCustomerFirstName,
  selectCustomerPhotoUri,
  selectCustomerId
} from '../../../store/selectors/customerProfile'
import { selectRouteKey } from '../../../store/selectors/routes'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'
import { PATH_HELPERS, OVERLAY_HELPERS } from '../../../constants/navigation'
import styles from './EmailUpdatesPanel.module.scss'

const MSG = defineMessages({
  heading: {
    id: 'EmailUpdates.panel.title',
    defaultMessage: 'Need to update your email?'
  },
  subTitle: {
    id: 'EmailUpdates.panel.subTitle',
    defaultMessage: '{customer} is happy to edit your email address for you. Send them a quick note:'
  },
  backButton: {
    id: 'EmailUpdates.panel.back.button',
    defaultMessage: 'Back'
  }
})

export const EmailUpdatesPanel = () => {
  const intl = useIntl()

  const customerFirstName = useSelector(selectCustomerFirstName)
  const avatarUri = useSelector(selectCustomerPhotoUri)
  const isProfile = selectRouteKey() === 'profile'
  const customerProfileId = useSelector(selectCustomerId)
  const topic = isProfile ? CUSTOMER_MESSAGES.BUYER_EMAIL_UPDATE : CUSTOMER_MESSAGES.HOMEOWNER_EMAIL_UPDATE

  const handleBackToPreferences = () =>
    isProfile
      ? history.push(PATH_HELPERS.profile.buildPath(customerProfileId))
      : history.push(OVERLAY_HELPERS.preferences.buildPath())

  return (
    <Page>
      <Page.Body className={styles.body}>
        <div className={styles.form}>
          <Text size='xl' variant='neutralCool' variantCount='900'>
            {intl.formatMessage(MSG.heading)}
          </Text>
          <Text size='s' variant='neutralCool' variantCount='600'>
            {intl.formatMessage(MSG.subTitle, { customer: customerFirstName })}
          </Text>
          <div className={styles.question}>
            <QuestionSingle
              questionTopic={topic.topic}
              questionTopicKey={topic.topicKey}
              placeholder={intl.formatMessage(topic.message)}
              avatarUri={avatarUri}
            />
          </div>
        </div>

        <Button onClick={handleBackToPreferences} fullWidth>
          {intl.formatMessage(MSG.backButton)}
        </Button>
      </Page.Body>
    </Page>
  )
}
